<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <UsersForm @submit-requested="submitRequested"></UsersForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import UsersForm from './UsersForm.vue'

  export default {
  components: { UsersForm },
  methods: {
    ...mapActions('users', ['postUser']),
    submitRequested (input) {
      this.postUser(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 